<template>
	<div class="wd-relative">
		<div class="wd-m-t-20 wd-m-b-20">
			<el-tabs type="border-card" v-model="orderstate" @tab-click="tapTab">
				<el-tab-pane label="可用优惠券" name="0">
				</el-tab-pane>
				<el-tab-pane label="已用优惠券" name="1">
				</el-tab-pane>
				<el-tab-pane label="过期优惠券" name="2">
				</el-tab-pane>
				<div class="wd-flex wd-row-left wd-flex-wrap">
					<div v-for="(item,index) in wddatalist" :key="index" class="couponlist wd-flex">
						<div class="wd-flex wd-row-between coupon">
							<div class="left wd-row-noshrink wd-flex" :class="getclass">
								<div class="value">{{item.numvalue}}</div>
								<div class="con">{{item.limitcon}}</div>			
							</div>
							<div class="right wd-row-grow wd-flex">
								<div class="wd-flex wd-row-left wd-width-percent-100">
									<div class="wd-row-grow ">
										<div class="name wd-flex wd-row-left">
										<span class="tag">{{item.typetext}}</span>
										{{item.name}}
										</div>
										<div class="date">{{item.datestart}}至{{item.dateend}}</div>
										<div class="stock">使用：{{item.limitstock}}</div>
										<div class="stock">平台：{{item.onlineflagtext}}</div>
									</div>
									<div class="state ">
										<div class="flag">
											<i class="wd-icon a0" v-if="orderstate==0">&#xe60d;</i>
											<i class="wd-icon a1" v-else-if="orderstate==1">&#xe67e;</i>
											<i class="wd-icon a2" v-else-if="orderstate==2">&#xe604;</i>
										</div>
										<div class="btn">
											<el-button type="" size="small" v-if="orderstate==0" @click="gotobuy">立即使用</el-button>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
				<div class="wd-fr">
					<el-pagination
						:total="cnt"
						:background="true"
						layout="prev, pager, next"
						@size-change="pagesizechange"
						@current-change="currentchange"
						@prev-click="prevclick"
						@next-click="nextclick"
					></el-pagination>
				</div>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Couponlist',
	data(){
		return{
			wddatalist:[],
			cnt:-1,
			page:0,
			oldorderstate:0,
			orderstate:"0"
		}
	},
	computed:{
		getclass:function(){
			switch (this.orderstate){
				case "0":return "";
				case "1":return "a1";
				case "2":return "a2";
			}
			return "";
		}
	},
	methods:{
		gotobuy(){
			this.$router.push("/");
		},
		pagesizechange(e) {
			this.page=e-1;
			this.loaddata();
		},
		currentchange(e) {
			this.page=e-1;
			this.loaddata();
		},
		prevclick(e) {
			this.page=e-1;
			this.loaddata();
		},
		nextclick(e) {
			this.page=e-1;
			this.loaddata();
		},
		tapTab(){
			if (this.oldorderstate!=this.orderstate){
				this.oldorderstate=this.orderstate;
				this.cnt=-1;
				this.wddatalist=[];
				this.loaddata();
			}
		},
		gotocouponcenter(){
			console.log("gotocouponcenter");
		},
		loaddata() {
			if (this.cnt==-1){
				this.page=1;
			}else{
				if (this.page*this.$wd_limit>=this.cnt){
					return;
				}else
					this.page++;
			}
			let indata={
				con:this.con,
				page:this.page,
				cnt:this.cnt,
				state:this.orderstate,
			}
			this.$wd_request('mycouponlist', indata,true,".memdetail").then(data => {
				this.wddatalist = data.value;
				if (this.page==1){
					this.cnt=data.cnt;
					this.wddatalist=data.value;
				}else{
					this.wddatalist=data.value;
				}
			});
		}
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
	.couponlist{
		margin-bottom: 10px;
		width: 49%;
		margin-right: 2%;	
		&:nth-child(2n){
		margin-right: 0;	
		}
		.coupon{
			width: 100%;
			.left{
				border: 1px solid #0ebe61;
				border-radius: 10px 0 0 10px;
				height: 120px;
				padding: 20px 10px;
				width: 120px;
				background-color: #0ebe61;
				color: #FFFFFF;
				text-align: center;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				.value{
					font-size: 30px;
				}
				.con{
					margin-top: 10px;
				}
				&.a1{
					background-color: $wd-warning;
					border: 1px solid $wd-warning;
				}
				&.a2{
					background-color: $wd-info;
					border: 1px solid $wd-info;
				}
			}
			.right{
				border: 1px solid #f9f9f9;
				border-radius: 0 10px 10px 0;
				height: 120px;
				padding: 20px 10px 20px 20px;
				background-color: #f9f9f9;
				color: #999;
				align-items: flex-start;
				flex-direction: column;
				.name{
					margin-bottom: 10px;
					font-size: 22px;
					.tag{
						background-color: $wd-warning;
						border-radius: 10px;
						color: #FFFFFF;
						font-size: 12px;
						padding: 2px 10px ;
						margin-right: 10px;
						flex-shrink: 0;
					}
				}
				.date{
					margin-bottom: 10px;
				}
				.stock{
					margin-bottom: 10px;
				}
				.state{
					width: 80px;
					position: relative;
					height: 100%;
					.flag{
						position: absolute;
						top: -20px;
						right: 0;
						.a0{
							font-size: 50px;
							color: $wd-success;
						}
						.a1{
							font-size: 50px;
							color: $wd-warning;
						}
						.a2{
							font-size: 50px;
							color: $wd-info;
						}
					}
					.btn{
						position: absolute;
						bottom: 0;
						right: 0;
					}
				}
			}
		}
	}
</style>
